export default "__VITE_ASSET__Eb8P8nk3__"